import { ApiError } from '@iris/shared';
import { ErrorScreen } from '@iris/ui/components/app-screens';
import { useTranslation } from 'react-i18next';
import { useRouteError } from 'react-router-dom';

/** Route-level error boundary (T4 §2.4): generic message, retry, request id for support. */
export function RouteError() {
  const error = useRouteError();
  const { t } = useTranslation();
  const requestId = error instanceof ApiError ? error.requestId : null;
  return (
    <ErrorScreen
      title={t('errorScreen.title')}
      body={t('errorScreen.body')}
      retryLabel={t('common.retry')}
      onRetry={() => window.location.reload()}
      reference={requestId ? t('common.requestId', { id: requestId }) : undefined}
    />
  );
}
